import styled from 'styled-components'

export const Loadings = styled.div`
    > * + * {
        margin-top: 20px;
    }
`

export const LoadingProductCard = styled.img`
    margin: 10px;
    opacity: 0.3;
    width: 230px;
    height: 325px;

    ${({ $active }) =>
        $active &&
        `
        animation: blink 1.5s infinite;
    `}
`

export const LoadingSlider = styled.div`
    display: flex;
    flex-wrap: wrap;

    justify-content: center;
    align-items: center;
`

export const LoadingProductContainer = styled.img`
    margin: 10px;
    opacity: 0.3;
    width: 1000px;
    height: 450px;

    ${({ $active }) =>
        $active &&
        `
        animation: blink 1.5s infinite;
    `}
`

export const LoadingProductContainerMobile = styled.img`
    margin: 10px;
    opacity: 0.3;
    height: 700px;
    width: 100%;

    ${({ $active }) =>
        $active &&
        `
        animation: blink 1.5s infinite;
    `}

    @media (max-width: 500px) {
        height: auto;
    }
`
